import type { FC } from "react";
import { isObject } from "@huub-web/utils";

import { Flex } from "../Flex";
import { Icon } from "../Icon";
import { Text } from "../Text";
import type { UserPromptRecord } from "../../types/UserPromptRecord";

export interface AskAITooltipContentProps {
  prompt?: UserPromptRecord;
}

/**
 * @deprecated
 */
export const AskAITooltipContent: FC<AskAITooltipContentProps> = ({
  prompt,
}) => (
  <Flex direction="column" gap="xxs">
    <Flex gap="xxs">
      <Icon icon="aiFilled" size="s" color="currentColor50" />
      <Text variant="bodyS" color="currentColor50">
        Vraag het Huub
      </Text>
    </Flex>
    <div>{isObject(prompt) ? prompt?.display : prompt}</div>
  </Flex>
);
